module.exports = __webpack_public_path__ + "img/LinfeiLi.05fba947.jpg";